import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import LangSwitch from './lang-switch';
import { Link } from 'react-router-dom';

const Navigation = (props: any) => {
  let [expanded, setExpand] = useState(false);
  const toggleNav = (value: boolean) => {
    setExpand(!expanded);
  }
  return (
    <Navbar expand="lg"  className={`bg-body-tertiary ${expanded ? 'visible-menu' : 'hidden-menu'}`}>
      <Container>
        {/* <Navbar.Brand href="/">Kate</Navbar.Brand> */}
        <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span></span>
            <span></span>
            <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {/* <Nav.Link href="/register">Register</Nav.Link>
            <Nav.Link href="/login">Login</Nav.Link> */}
            {props.signIn ? (
              <Nav.Link as={Link} to="/moodboard" className='moodboard'></Nav.Link>
            ) : null}
            {props.signIn ? (
              <Nav.Link as={Link} to="/cart" className='basket'></Nav.Link>
            ) : null}
            {props.signIn ? (
              <Nav.Link as={Link} to="/me" className='prof-icon'></Nav.Link>
            ) : null}
            {props.signIn ? (
              <Nav.Link as={Link} to="/" className='search-icon'><span className='search-btn'></span></Nav.Link>
            ) : null}
             {/* {props.signIn ? (
              <Nav.Link as={Link} to="/contact" className='contact-icon'></Nav.Link>
            ) : null} */}
            <LangSwitch sendToggle={toggleNav} expanded={expanded} />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;